import type { CSSProperties } from 'react';

import { VFlex } from '@/components/base';
import Transition from '@/components/Common/Transition';
import Portal from '@/components/Portal/Portal';
import { StyledTooltip } from '@/components/Tooltip/TooltipRenderer';

import CategoryBadge from '../../field/Category/CategoryBadge';
import { ContentOriginBadge } from '../../field/ContentOrigin';
import SentimentBadge from '../../field/Sentiment/SentimentBadge';

type Props = {
  tooltipInfo: {
    blockId?: string;
    pos?: CSSProperties;
    status: boolean;
  };
  currentBlockInfo: FeedbackBlockT | null;
};

const FeedbackBlockTooltip = (props: Props) => {
  return (
    <Portal id="tooltip-layer">
      <Transition status={props.tooltipInfo.status}>
        <StyledTooltip
          style={{
            ...props.tooltipInfo?.pos,
            minWidth: 160,
            padding: 16,
          }}
        >
          {props.tooltipInfo && props.currentBlockInfo && (
            <VFlex g={10}>
              <SentimentBadge
                type={props.currentBlockInfo.sentiment}
                size="m"
              />
              <CategoryBadge category={props.currentBlockInfo.category} />
              <ContentOriginBadge
                contentOrigin={props.currentBlockInfo.content_origin}
              />
            </VFlex>
          )}
        </StyledTooltip>
      </Transition>
    </Portal>
  );
};

export default FeedbackBlockTooltip;
